module.exports = __webpack_public_path__ + "static/img/pic-bonus.67e8e6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build821/assets/image/invitation/pic-bonus.png
// module id = WLDy
// module chunks = 0 2